// extracted by mini-css-extract-plugin
export default {"input":"NumberInput_input__p0Fu5"};